import { render, staticRenderFns } from "./CommentCard.vue?vue&type=template&id=5b0cf6d6&scoped=true&"
import script from "./CommentCard.vue?vue&type=script&lang=js&"
export * from "./CommentCard.vue?vue&type=script&lang=js&"
import style0 from "./CommentCard.vue?vue&type=style&index=0&id=5b0cf6d6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0cf6d6",
  null
  
)

export default component.exports